export const COGNITO = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_Xmf16DB6E",
  APP_CLIENT_ID: "kqeurn958ojts4k2f33nsrc46",
};

export const API = {
  URL_BASE: "https://revolution-four-node.salutations.world/api/",
};
